import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Notify from "../../../Notify";
import { getData, putData } from "../../../../services/library";
import { registrarAccion, DONDE } from "../../logs/registrarAccion";

function BajaClienteEnv(props) {
  const [datosCliente, setDatosCliente] = useState(props.cliente);
  const [disBtn, setDisBtn] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const [hojas, setHojas] = useState(null);

  useEffect(() => {
    if (props.open && datosCliente?.id) {
      getData("/envasado_clientes_ruta/verificacion/" + datosCliente.id, setHojas);
    }
  }, [props.open, datosCliente?.id]);

  const handleClose = () => {
    props.setOpen(false);
  };


  async function marcarInactivo(e) {
    setDisBtn(true);
    await putData(
      e,
      "/envasado_clientes/" + datosCliente.id,
      {
        activo: 0,
      },
      setNotificacion
    );
    registrarAccion(DONDE.CLIENTES, `Baja de cliente ${datosCliente.id} - ${datosCliente.razon_social}`);
  }

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.actualizar();
              props.setOpen(false);
              setNotificacion({ open: false });
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <form onSubmit={marcarInactivo}>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Baja de cliente: {datosCliente.razon_social}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            {hojas && hojas.length > 0 && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                El cliente está asignado a las siguientes hojas de ruta:
                <ul style={{ margin: 0 }}>
                  {hojas.map((h) => (
                    <li key={h.id}>
                      {h.nombre_hoja} 
                    </li>
                  ))}
                </ul>
              </Alert>
            )}
            <DialogContentText textAlign={"center"}>
              ¿Seguro que quiere dar de baja al cliente?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button color="success" type="submit" variant="contained"  disabled={disBtn || hojas === null}>
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default BajaClienteEnv;
